import gql from 'graphql-tag';

export const GET_ADMIN_SERVICE_REQUESTS = gql`
	query GetAdminServiceRequests($id: String, $status: String, $query: JSON, $editor: String, $limit: Int, $offset: Int) {
		serviceRequests(id: $id, status: $status, query: $query, editor: $editor, limit: $limit, offset: $offset) {
			id
			createdAt
			accepted
			additionalInfo
			service {
				id
				property {
					id
					streetAddress
					city
					state
					zipCode
				}
			}
			editor {
				id
				name
				email
				image
			}
			flags
			isActive
			isApproved
			status
			type
		}
	}
`;
